import { faCheck } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { makeStyles } from "@material-ui/core";
import React from "react";

const useBulletPointsStyles = props => makeStyles((theme) => ({
    pointsContainer: {
        [theme.breakpoints.down("sm")]: {
            flexDirection: 'column'
        },
        display: 'flex',
        flexWrap: 'wrap',
        gap: '0.5rem',
        justifyContent: "space-between",
        flexDirection: props?.showInColumn ? 'column' : 'row',
        '& > div': {
            flexBasis: "48%"
        }
    },
    tickWithTextCon: {
        display: 'flex',
        gap: '0.5rem',
        alignItems: "center"
    }
}))

const BulletPoints = (props) => {
    const classes = useBulletPointsStyles(props)();
    const jobDescPoints = [
        "Integer a velit ut sapien consectetur laoreet.", "Integer a velit ut sapien consectetur laoreet.",
        "Integer a velit ut sapien consectetur laoreet.", "Integer a velit ut sapien consectetur laoreet."
    ];
    return (
        <div className={classes.pointsContainer}>
            {jobDescPoints.map((val, idx) =>
                <div className={classes.tickWithTextCon} key={idx + val}>
                    <FontAwesomeIcon icon={faCheck} size="1x" color="#315CD5" />
                    <span>{val}</span>
                </div>
            )}
        </div>
    )
}

export default BulletPoints;